<template>
    <div class="bg-login px-5">
        <div class="col-md-5 col-sm-9 col-11 mx-auto" style="padding-top: 16%;">
            <div class="px-sm-5 p-5" style="border: none;background-color: #021d4ca1;color: white;border-radius: 30px;">
                <div class="px-sm-5 px-md-4">
                    <div class="mx-auto text-center">
                        <img src="../../public/img/heyva-logo.png" class="img-width" alt="">
                    </div>
                    <div class="row my-3 text-end">
                        <input type="text" class="w-100 py-3" v-model="phone" placeholder="شماره تلفن">
                        <input type="password" class="w-100 mt-3 py-3" v-model="password" placeholder="رمز عبور">
                        <div class="text-center">
                            <button class="bt-login mt-4 px-5 fs-6" @click="login()">ورود</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import { defineComponent, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';

export default defineComponent({
    setup() {
        const phone = ref('')
        const password = ref('')
        const router = useRouter()
        
        onMounted(() => {
            if (localStorage.getItem('credits')) {
                router.push({ name: 'online-signals' })
            }
        })

        function login() {
            if (!phone.value || !password.value) {
                Swal.fire({ text: "لطفاً شماره تلفن و رمز را وارد کنید", icon: "warning" })
                return;
            }
            
            axios.put('https://api.xaifin.com/user/login', {
                'username': phone.value,
                'password': password.value
            }).then((res) => {
                console.log('Login response:', res.data);
                
                
                localStorage.setItem('credits', res.data.user.credits);
                localStorage.setItem('users', phone.value);
                
                // اگر توکن برگشت، ذخیره شود
                if (res.data.token) localStorage.setItem('token', res.data.token);
                else if (res.data.user && res.data.user.token) localStorage.setItem('token', res.data.user.token);
                
                console.log('Credits saved (default if missing):', res.data.user.credits);
                
                // نمایش پیام موفقیت و هدایت
                Swal.fire({
                    icon: 'success',
                    text: 'ورود موفقیت‌آمیز بود',
                    timer: 1500,
                    showConfirmButton: false
                });
                router.push({ name: 'online-signals' });
                
            }).catch((error) => {                    
                Swal.fire({
                    text: error.response?.data?.mess || "خطا در ارتباط با سرور",
                    icon: "error"
                });
            });
        }

        return {
            phone,
            password,
            router,
            login
        }
    }
})
</script>

<style scoped lang="scss">
.bg-login {
    height: 100vh;
    background-image: url('../../public/img/bg3.jpg');
    background-size: cover;
}
.bt-login {
    background-color: #d4af37;
    border: none;
    border-radius: 50px;
    padding: 10px 30px;
    color: #021d4c;
    font-size: 15px;
    font-weight: 700;
}
.img-width {
    width: 200px;
    @media(max-width:576px) {
        width: 100px;
    }
}
</style>